import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

/**
* This component should not display 'undefined' values.
* It should not override the default page title and page descriptions when its props are not defined.
*/
export default class HelmetWidget extends Component {
  static propTypes = {
    companyName: PropTypes.string,
    pageDescription: PropTypes.string,
    pageTitle: PropTypes.string,
    widgetName: PropTypes.string,
    widgetType: PropTypes.string
  }

  getDefaultTitle () {
    switch (this.props.widgetType) {
      case 'article':
        return 'Conseils & astuces'
      case 'catalog':
        return 'Conseils d\'experts'
      case 'diagnostic':
        return 'Diagnostic en ligne'
      case 'tutoriel':
        return 'Tutoriel de réparation'
      default:
    }
  }

  render () {
    const pageTitle = this.props.pageTitle ||
        (this.props.widgetName ? `${this.props.widgetName} | ` : '') +
        (this.props.widgetType ? this.getDefaultTitle() : '') +
        (this.props.companyName ? ` | ${this.props.companyName}` : '')
    return (
      <Helmet>
        {pageTitle && <title>{pageTitle}</title>}
        {this.props.pageDescription && <meta name='description' content={this.props.pageDescription} />}
      </Helmet>
    )
  }
}
